export default "__VITE_ASSET__jhekOy6M__"